import { Box, Stack } from '@mui/material';
import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import moment from 'moment';

export default function CurrentDate({selectedDay}) {
    return (
        <Box>
            <Stack direction="row" justifyContent="left" alignItems="baseline" >
                <text className='small-header white bold'>{moment(selectedDay).format("MMMM D, YYYY")}</text>
            </Stack>
        </Box>
    )
}
